module.exports = __webpack_public_path__ + "static/media/pic12.a544a87e.jpg";